/** Cart, checkout, shop chrome, navigation — merged into store_copy. */

export const STORE_UI_COPY_DEFAULTS = {
  // Shop page
  shop_search_placeholder: 'Search by product name or ID…',
  shop_search_button: 'Search',
  shop_loading_categories: 'Loading latest categories…',
  shop_category_desc_template: 'Browse {count} handcrafted design(s).',
  shop_category_desc_singular: 'Browse 1 handcrafted design.',
  shop_category_empty: 'Collection coming soon.',
  shop_category_count: '{count} design(s)',
  shop_category_count_singular: '1 design',
  shop_category_coming_soon: 'Coming soon',

  // Global nav (header)
  nav_home: 'Home',
  nav_shop: 'Shop',
  nav_about: 'About',
  nav_contact: 'Contact',
  nav_track_order: 'Track order',
  nav_search_placeholder: 'Search name or ID…',
  skip_to_main: 'Skip to main content',

  // Footer nav links
  footer_nav_home: 'Home',
  footer_nav_shop: 'Shop',
  footer_nav_search: 'Search products',
  footer_nav_blog: 'Styling ideas',
  footer_nav_track_order: 'Track order',
  footer_nav_wishlist: 'Wishlist',
  footer_nav_account: 'My account',
  footer_nav_sign_in: 'Sign in',
  footer_nav_shipping: 'Shipping',
  footer_nav_returns: 'Returns',
  footer_nav_privacy: 'Privacy',
  footer_tagline_fallback: 'Handcrafted Rakhi & Lumba',
  footer_location: 'India',
  footer_studio_maps: 'Open in Maps',
  footer_studio_instagram: 'Instagram',
  footer_studio_whatsapp: 'WhatsApp',

  // Shop nav menu
  shop_nav_browse_all: 'Browse all designs',
  shop_nav_view_all: 'View all',
  shop_nav_overview: 'Shop overview',
  shop_nav_mobile_browse: 'Browse collections',
  shop_nav_mobile_close: 'Close shop collections',
  shop_nav_all_collections: 'All collections',
  shop_nav_browse: 'Browse',

  // Cart page
  cart_item_singular: 'item',
  cart_item_plural: 'items',
  cart_item_count_aria: '{count} items in bag',
  cart_line_price_each: '{price} each',
  cart_line_in_stock: '{count} in stock',
  cart_line_quantity: 'Quantity',
  cart_line_total: 'Line total',
  cart_continue_shopping: 'Continue shopping',
  cart_checkout_button: 'Proceed to checkout',
  cart_empty_account_button: 'My account',
  cart_empty_track_button: 'Track order',
  cart_empty_shop_button: 'Shop collections',
  cart_summary_footnote_authed: 'Delivery fee is calculated at checkout based on your PIN code.',
  cart_summary_footnote_guest:
    'Sign in for saved addresses, or continue as guest — delivery fee is calculated at checkout.',
  cart_sign_in_nudge_before: 'Sign in',
  cart_sign_in_nudge_after: 'for saved addresses and order history.',
  cart_mobile_subtotal: 'Subtotal',
  cart_mobile_checkout: 'Checkout',

  // Cart drawer
  cart_drawer_title: 'Your bag ({count})',
  cart_drawer_empty_lead: 'Your bag is empty — explore our collections.',
  cart_drawer_shop_button: 'Shop collections',
  cart_drawer_checkout: 'Checkout',
  cart_drawer_view_bag: 'View full bag',
  cart_drawer_edit_bag: 'Edit items & delivery',
  cart_drawer_subtotal: 'Subtotal',

  // Checkout
  checkout_title: 'Checkout',
  checkout_lead: 'We ship across India. Enter your details and choose how to pay.',
  checkout_empty_view_bag: 'View bag',
  checkout_empty_shop: 'Shop collections',
  checkout_guest_note:
    'Already have an account? Sign in for saved addresses. You can also track orders or reset your password.',
  checkout_section_contact: 'Contact',
  checkout_section_notes: 'Order notes',
  checkout_section_address: 'Delivery address',
  checkout_pin_intro: 'Enter your PIN code first — we use it for delivery fee and estimated dispatch.',
  checkout_field_name: 'Full name',
  checkout_field_phone: 'Mobile number',
  checkout_field_phone_hint: 'For delivery updates',
  checkout_field_email: 'Email',
  checkout_field_pin: 'PIN code',
  checkout_pin_hint: '6-digit postal PIN',
  checkout_field_email_hint_guest: 'For order updates',
  checkout_field_city: 'City / district',
  checkout_field_state: 'State',
  checkout_field_state_placeholder: 'Select state',
  checkout_field_address: 'Street address',
  checkout_field_address_placeholder: 'House no., street, landmark',
  checkout_field_notes: 'Order notes (optional)',
  checkout_field_notes_placeholder: 'Gift message, delivery instructions…',
  checkout_saved_address_filled: 'Filled from your last order — edit if needed.',
  checkout_saved_address_using: 'Using saved address from your account.',
  checkout_pay_processing: 'Processing…',
  checkout_pay_online: 'Pay {total}',
  checkout_pay_offline: 'Place order · {total}',
  checkout_secure_online: 'Secure payment via Razorpay. Your card details are never stored on our site.',
  checkout_secure_offline: 'We will confirm your order and share payment instructions if needed.',
  checkout_pending_payment: 'Your order is saved — complete payment to confirm. Check your email or contact us.',
  checkout_progress_cart: 'Cart',
  checkout_progress_details: 'Details',
  checkout_progress_payment: 'Payment',

  // Order summary panel
  order_summary_title: 'Order summary',
  order_summary_subtotal: 'Subtotal',
  order_summary_delivery: 'Delivery',
  order_summary_delivery_free: 'Free',
  order_summary_total: 'Total',
  order_summary_promo: 'Promo',
  order_summary_edit_bag: 'Edit bag',
  order_summary_qty: 'Qty',

  // Checkout confidence / extras
  checkout_back_to_bag: 'Back to bag',
  checkout_back_to_bag_hint: 'Review or edit your items',
  checkout_confidence_badge_empty: 'Your bag',
  checkout_confidence_badge_one: '1 item in bag',
  checkout_confidence_badge_many: '{count} items in bag',
  checkout_coupon_prompt: 'Have a promo code?',
  checkout_coupon_apply: 'Apply',
  checkout_coupon_applied: 'Promo applied',
  checkout_payment_options: 'Payment options',
  checkout_pay_online_method: 'Pay online now (UPI / card / netbanking)',
  checkout_pay_offline_method: 'Pay later (WhatsApp / bank transfer — we confirm your order)',
  checkout_confidence_items: '{count} items',

  // Free shipping nudge
  free_shipping_qualified: 'You qualify for free delivery on this order.',
  free_shipping_add_more: 'Add {amount} more for free delivery.',

  // Wishlist nudge
  wishlist_nudge_view: 'View saved items',
  wishlist_nudge_dismiss: 'Dismiss',
  wishlist_nudge_count_singular: '1 saved item',
  wishlist_nudge_count_plural: '{count} saved items',

  // Home microcopy
  home_assistant_eyebrow: 'Smart assistant',
  home_blog_card_eyebrow: 'Story',
  home_blog_read_label: 'Read article',
  home_merchandising_cta_fallback: 'Learn more',
  home_shelf_title_fallback: 'Featured',
  home_shelf_soon: 'Soon',

  // Pull to refresh (mobile home)
  pull_refresh_pull: 'Pull to refresh',
  pull_refresh_release: 'Release to refresh',
  pull_refresh_refreshing: 'Refreshing…',
};
